var path = 'areas/projects/views/release_create.html';
var html = " <script octo-section=breadcrumbs type=text/ng-template> <li ng-hide='originalVersion'><a href='#/projects/{{ project.Slug }}/releases/create'>Create</a></li> </script> <release-editor></release-editor>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/release_create.html
// module id = 1666742638710454
// module chunks = 1